import { type Clip } from '@air/types';

const DEFAULT_FPS = 24;

export const getVideoFps = (clip: Pick<Clip, 'frameCount' | 'duration'>) => {
  if (clip.frameCount && clip.duration && clip.duration > 0) {
    return clip.frameCount / clip.duration;
  }

  return DEFAULT_FPS;
};
